{
    "ModalTitleStatusChange": "Accesso agente ACD",
    "LocationStatusTitle": "Posizione",
    "LocationStatusDescription": "Scegliere un dispositivo e un agente ACD per accedere.",
    "StatusOptionsTitle": "Opzioni",
    "AcdGroupOptionsDescription": "Se il server telefonico di destinazione lo supporta, è possibile scegliere il gruppo ACD per il quale modificare specificamente lo stato ACD selezionato.",
    "AcdGroupLabel": "Gruppo ACD",
    "AcdAgentLabel": "Agente ACD",
    "FooterButtonOk": "OK",
    "FooterButtonCancel": "Annullamento",
    "FooterButtonHelp": "Aiuto",
    "StatusChange_PromptMessage": "Tutte le configurazioni andranno perse alla chiusura. Siete sicuri di voler chiudere questa finestra?",
    "StatusChange_PromptConfirm": "Sì",
    "StatusChange_PromptCancel": "Annullamento",
    "StatusChange_DevicesLabel": "Dispositivo",
    "NAME": "StatusChange"
}